/* Add to Registry CTA — gifts icon for the Gift Reggie PDP button.
   (Figma cta.addtoregistry 383:1842; styling in ap-registry-cta.css.)
   Loaded by snippets/ap-registry-cta.liquid. Gift Reggie renders its button
   asynchronously and re-renders it on state changes, so we watch the
   product info column and (idempotently) prepend the icon whenever a
   registry button without one appears. Moved out of ap-monogram-drawer.js
   on 10/1/26 so product templates without the drawer get the same CTA. */
(function () {
  'use strict';

  /* Two snippets can render ap-registry-cta on one page (the monogram drawer
     and text-to-order both do); run once. */
  if (window.apRegistryCtaLoaded) return;
  window.apRegistryCtaLoaded = true;

  /* Two-gifts icon. Strokes use currentColor so it picks up the button's
     peach; the front box is filled with the button cream so it occludes the
     tall gift behind it. */
  var GIFTS_ICON_SVG =
    '<svg class="ap-registry-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<g fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M4 8.5h7.5V20H5a1 1 0 0 1-1-1V8.5z"/>' +
    '<path d="M7.75 8.5c-1.9 0-3-.95-3-1.95 0-.95 1.3-1.4 2.1.25.5 1 .9 1.7.9 1.7z"/>' +
    '<path d="M7.75 8.5c1.9 0 3-.95 3-1.95 0-.95-1.3-1.4-2.1.25-.5 1-.9 1.7-.9 1.7z"/>' +
    '</g>' +
    '<rect x="10.5" y="11.5" width="10.5" height="8.5" rx="1" fill="#fff9ea" stroke="currentColor" stroke-width="1.6"/>' +
    '<path d="M15.75 11.5V20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';

  function decorateRegistryButton() {
    var btns = document.querySelectorAll(
      '.product-info .shopify-app-block a, .product-info .shopify-app-block button'
    );
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.querySelector('.ap-registry-icon')) return;
      if (!/registry/i.test(btn.textContent)) return;
      var holder = document.createElement('span');
      holder.innerHTML = GIFTS_ICON_SVG;
      btn.insertBefore(holder.firstElementChild, btn.firstChild);
    });
  }

  function init() {
    decorateRegistryButton();
    var scope = document.querySelector('.product-info') || document.body;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        decorateRegistryButton();
      });
    }).observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
